export enum PaymentMethod {
  TELCELL = "TELCELL",
  IDRAM = "IDRAM",
  EASY_WALLET = "EASY_WALLET",
  CREDIT_CARD = "CREDIT_CARD",
  MY_PAY = "MY_PAY",
  FASTSHIFT = "FASTSHIFT",
}
